// @flow
import React from 'react';
import { Container, Row, Col } from 'Components/Grid';
import Icon from 'Components/Icon';
import ConsumptionData from 'Components/ConsumptionData';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import { stripTags } from 'Utils';
import { getGivenBackground, hasDarkBackground } from 'Utils/getColor';
import CallToAction from 'Components/CallToAction';
import Typography from 'Components/Typography';
import RichText from 'Components/RichText';

const cx = classNames.bind(styles);

type Props = {
  background: String,
  align: String,
  headline?: String,
  cols: Array<Object>,
  deeplinkId?: number,
};

export default class GridContentBox extends React.Component<Props> {
  render() {
    const { background, headline, cols, align, deeplinkId, consumptionText } = this.props;
    const colSize = 12 / cols.length;
    const hasDarkBg = hasDarkBackground(background);

    const containerClass = cx('container', {
      [background]: true,
      overwriteFonts: background === getGivenBackground('dark'),
    });

    return (
      <div className={containerClass} id={deeplinkId}>
        <Container>
          {headline && (
            <Row align="center">
              <Col cols={12} m={10} l={8} className={styles.col}>
                <Typography.Headline
                  className={styles.headline}
                  additionalAriaLabelText={consumptionText}
                  {...headline}
                />
              </Col>
            </Row>
          )}
          <Row>
            {cols.map((col, i) => (
              <Col
                key={'col' + i}
                cols={12}
                m={colSize}
                className={styles.col}
                stretch
                valign={align === 'center' || align === 'bottom' ? align : undefined}
              >
                <div className={styles.contentBox}>
                  {col.icon && (
                    <div className={styles.icon}>
                      <Icon name={col.icon} inline={false} />
                    </div>
                  )}
                  {col.headline && (
                    <Typography.Headline className={styles.columnHeadline} {...col.headline} />
                  )}
                  {col.bodyText && (
                    <RichText
                      className={styles.text}
                      content={col.bodyText}
                      hasDarkBackground={hasDarkBg}
                    />
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Container>
        {consumptionText && (
          <ConsumptionData consumptionText={[consumptionText]} ariaHidden={true} />
        )}
      </div>
    );
  }
}
